<template>
  <pre class="code">
    <code>
      <slot />
    </code>
  </pre>
</template>

<script>
export default {};
</script>

<style lang="scss">
code,
kbd,
tt,
var,
samp,
pre {
  font-family: Inconsolata, monospace;
}

pre {
  background: #f7f7f7;
  color: #37474f;
  border: 1px solid $color-tom-thumb;
  border-left-width: 5px;
  font-size: 15px;
  font-size: 1rem;
  line-height: 1.3125;
  margin: 0 0 1.75em;
  max-width: 100%;
  overflow: auto;
  padding: 0.5em 0.6em 0.5em 0.8em;
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: break-word;
}

code {
  background-color: #f7f7f7;
  padding: 0.125em 0.25em;
}

pre > code {
  background: none;
  padding: 0;
  margin: 0;
}

.code {
  position: relative;

  &--disabled {
    opacity: 0.4;
    pointer-events: none;
  }
}

.code-actions {
  display: flex;
  position: absolute;
  right: 0;
  top: 0;
}

.code-actions__btn {
  background: rgba(#000, 0.55);
  border: none;
  color: #fff;
  cursor: pointer;
  height: 36px;
  font-size: 18px;
  position: relative;
  transition: all 0.2s;
  width: 36px;

  &:hover,
  &:focus {
    background: rgba(#000, 0.9);
  }

  &:disabled {
    background: rgba(#000, 0.55);
  }

  .icon {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
